<script>
export default {
  name: 'FormGuideSortSelect',
  props: {
    optionsGroup: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      label: this.$slots.default[0].text,
      selected: '',
      opened: false,
    };
  },
  watch: {
    selected(value) {
      this.$emit('input', value);
    },
  },
  methods: {
    handleClick(event) {
      const { value: assignedValue } = event.target.dataset;
      if (assignedValue) {
        this.selected = assignedValue;
      }

      this.hideDropdown();
    },
    hideDropdown() {
      this.opened = false;
      this.updateLabel();
    },
    showDropdown() {
      this.opened = true;
      this.updateLabel();
    },
    updateLabel() {
      let label;
      if ((label = this.getLabelValue())) {
        this.label = label;
      } else {
        this.label = this.$slots.default[0].text;
      }
    },
    getLabelValue() {
      let label = '';
      let arrObj = Object.values(this.optionsGroup);
      arrObj = arrObj.flat(); // Flattening nested arrays
      arrObj.map(option => {
        if (option.value === this.selected) {
          label = option.text;
        }
      });
      return label;
    },
  },
};
</script>


<template>
  <div class="form-guide-sort-select__container">
    <select v-model="selected">
      <optgroup v-for="(group, groupName) in optionsGroup" :key="group.value" :label="groupName">
        <option
          v-for="option in group"
          :key="option.value"
          :value="option.value"
          :selected="option.value === selected"
        >{{ option.text }}</option>
      </optgroup>
    </select>

    <ul :class="[{opened}]" @mouseleave="hideDropdown">
      <!-- selected dropdown filter -->
      <li
        v-if="$slots.default"
        data-value
        data-disabled="true"
        class="dropdownLabel"
        @mouseover="showDropdown"
      >
        {{ label }}
        <!-- more info down arrow -->
        <svg width="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <path
            d="m12.682 4.018c.3 0 .5.1.7.3.4.4.4 1 0 1.4l-4.5 4.5 4.5 4.5c.4.4.4 1 0 1.4s-1 .4-1.4 0l-6-6 6-6c.2 0 .4-.1.7-.1"
            fill="#333732"
          />
        </svg>
      </li>

      <!-- dropdown options -->
      <li class="form-guide-sort-select__container__submenu">
        <ul
          v-for="(group, groupName) in optionsGroup"
          :key="group.value"
          :data-value="group.value"
          :data-selected="group.value === selected"
          class="form-guide-sort-select__group-name"
        >
          {{ groupName }}
          <li
            v-for="option in group"
            :key="option.value"
            :data-value="option.value"
            :data-selected="option.value === selected"
            :class="[{'selected': option.value === selected}]"
            class="form-guide-sort-select__option-name"
            @click="handleClick"
          >
            {{ option.text }}
            <!-- selected tick arrow -->
            <svg
              v-show="option.value === selected"
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
            >
              <path d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z" />
            </svg>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>
